import React from 'react';
import { ClientContext } from '@thd-nucleus/app-render/dist/client';
import { Logger } from '@thd-olt-component-react/logger';
import B2BTheme from '@thd-olt-global/b2b-theme';
import { NewRelicBridge } from '@thd-olt-component-react/new-relic-bridge';
import { whyDidYouRender } from '../wdyr';
import { App } from './App';
import { getRoutes, getServerPages } from './routes';

NewRelicBridge.init();
whyDidYouRender.init();

document.addEventListener('DOMContentLoaded', async () => {
  const client = new ClientContext({
    opts: {
      federation: true,
    },
  });
  client.setExperienceRoutes(getRoutes());

  const isLocal = process.env.EXECUTION_PLATFORM === 'local';
  if (isLocal && process.env.DEV_RUNNER === 'vite') {
    server.addToHead(`
    <script type="module">
       import RefreshRuntime from "/@react-refresh"
       RefreshRuntime.injectIntoGlobalHook(window)
       window.$RefreshReg$ = () => {}
       window.$RefreshSig$ = () => (type) => type
       window.__vite_plugin_react_preamble_installed__ = true
     </script>
     <script type="module" src="/@vite/client"></script>
   `);
    server.addToPostBody(`<script type="module" src="/src/client.jsx"></script>\n`);
  }

  if (client.customer.type === 'b2b') {
    client.setTheme({ name: 'b2b', template: B2BTheme });
  }

  const serverPages = await getServerPages();

  client.render(
    <Logger>
      <App
        prefetchPip={client.featureSwitches.prefetchPip}
        productPodHoverDelay={client.featureSwitches.productPodHoverDelay}
        serverPages={serverPages}
      />
    </Logger>
  );
});
